// extracted by mini-css-extract-plugin
module.exports = {"label":"_1qADJ","size_large":"Rhyjj","size_small":"VPbEv","date":"YhdHl","screenreaderText":"kiRjw"};